


document.addEventListener('DOMContentLoaded', function () {
	const splideElem = document.querySelector('.mm-splide-club');

	if (!splideElem) {
		return;
	}

	const progressBar = splideElem.querySelector('.mm-splide-progress-bar');

	const splideCards = new Splide(splideElem, {
		type: 'slide',
		arrows: false,
		pagination: false,
		autoWidth: true,
		// easing: 'cubic-bezier(0.55, 0, 0.12, 1)',
		perMove: 1,
		perPage: 1,
		omitEnd: true,
		gap: 16,
		breakpoints: {
			768: {
				gap: 16
			},
		},
	});

	// Maj progress bar seulement si elle existe
	if (progressBar) {
		const updateProgressBar = () => {
			const totalSlides = splideCards.Components.Elements.slides.length;
			const currentSlide = splideCards.index + 1;
			const progress = (currentSlide / totalSlides) * 100;
			progressBar.style.width = `${progress}%`;
		};

		splideCards.on('move', updateProgressBar);
		splideCards.on('mounted', updateProgressBar);
	}

	splideCards.mount();

	// autoWidth : la largeur des cartes dépend des images (lazy), Splide doit remesurer la butée de fin une fois chargées
	splideElem.querySelectorAll('.splide__slide img').forEach((img) => {
		if (!img.complete) {
			img.addEventListener('load', () => splideCards.refresh(), { once: true });
		}
	});

	// Ajout : on force le recalcul de ScrollTrigger après le montage du Splide
	if (window.ScrollTrigger) {
		window.ScrollTrigger.refresh();
	}
});
